/* eslint-disable import/prefer-default-export */
export const estadosDelPadronEnum = Object.freeze({
  INGRESADO: 1,
  ACTIVO: 2,
  SUSPENDIDO: 3,
  BAJA: 4,
  DEPENDIENTE: 5,
  EN_AUDITORIA: 6,
});
